window.activityLogDetailFormatter = function(value, row) {
    let html = '';
    let json_properties = JSON.parse(row.properties);
    html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<th style="padding: 8px; width: 220px !important">'+__('Column')+'</th>';
    if (json_properties.hasOwnProperty('old')) {
        html += '<th style="padding: 8px; width: 220px !important">'+__('Old Value')+'</th>';
    }
    if (json_properties.hasOwnProperty('attributes')) {
        html += '<th style="padding: 8px; width: 220px !important">'+__('New Value')+'</th>';
    }
    if (!json_properties.hasOwnProperty('old') && !json_properties.hasOwnProperty('attributes')) {
        html += '<th style="padding: 8px; width: 220px !important">'+__('Value')+'</th>';
    }
    html += '<th>&nbsp;</th>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    let values = json_properties.hasOwnProperty('old') ? json_properties['old'] : json_properties;
    values = json_properties.hasOwnProperty('attributes') ? json_properties['attributes'] : json_properties;
    if (row.raw_event === null) {
        values = json_properties;
    }
    if (values != null && Object.keys(values).length > 0) {
        let keys = Object.keys(values);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            html += '<tr>';
            // Column
            html += '<td style="padding: 8px">'+key+'</th>';
            // Old Value
            if (json_properties.hasOwnProperty('old')) {
                html += '<td style="padding: 8px !important; background: #FFE9E9 !important; color: #333 !important">';
                html += json_properties['old'][key];
                html += '</th>';
            }
            // New Value
            if (json_properties.hasOwnProperty('attributes')) {
                html += '<td style="padding: 8px!important; background: #E9FFE9 !important; color: #333 !important">';
                html += json_properties['attributes'][key];
                html += '</th>';
            }
            // Value
            if (!json_properties.hasOwnProperty('old') && !json_properties.hasOwnProperty('attributes')) {
                html += '<td style="padding: 8px!important; color: #333 !important">';
                html += json_properties[key];
                html += '</th>';
            }
            html += '<td>&nbsp;</td>';
            html += '</tr>';
        }
    }
    html += '</tbody>';
    html += '</table>';
    return html;
};
